import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { sellPolicyData } from "../addpolicy/sellpolicyData.model";
import { AuthService } from "../core/auth/auth.service";
import { AppConfig } from "src/config/app.config";
import { DatastorageService } from "../datastorage.service";
import * as moment from "moment";
import { Router } from "@angular/router";
import { MESSAGE_CONSTS } from "../ValidationMessages";
import { Step } from "../core/step.model";
import { CustomErrorHandler } from "../core/custom-error-handler";
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { PolicyStatus } from "../core/policyStatus.model";

@Component({
  selector: "app-vehicledetails",
  templateUrl: "./vehicledetails.component.html",
  styleUrls: ["./vehicledetails.component.css"],
})
export class VehicledetailsComponent implements OnInit {
  private _apiUrl: string;

  public inclusiveCoverage: number;
  public maxvehage: number;
  vehicleDetailForm: FormGroup;
  sellPolicyData: sellPolicyData = new sellPolicyData();
  clientId: number;
  userId: number;
  modelList = [];
  colorList = [];

  isExtend: boolean = false;
  isAged: boolean = false;
  maxInsured: boolean = false;
  vinNumber: any = null;
  expiryDateofExistingPolicy: Date;
  isAlreadySaled: boolean = false;
  isEnableAutoValidate: boolean = false;
  clientName: string;
  step: Step = new Step();
  maxDate: moment.Moment;
  @ViewChild("policySearchModal") templateRef: TemplateRef<any>;
  templateDialogRef: NxModalRef<any>;
  isUnitySearch: boolean;
  maxYearsEligible: string;
  selectedModel: any;
  vehicleAge: number;
  policyStartDate: Date;
  policyEndDate: Date;
  selectedColor: any[];
  isSellCancelledPolicyAgain: boolean = false;
  lastavailDate: Date;
  CancellationApprovalPending: boolean = false;

  constructor(
    private authService: AuthService,
    private appConfig: AppConfig,
    private dataService: DatastorageService,
    private router: Router,
    private customErrorHandler: CustomErrorHandler,
    public dialogService: NxDialogService
  ) {
    this.clientId = parseInt(atob(localStorage.getItem("CLIENT_ID")));
    this.clientName = localStorage.getItem("CLIENT_NAME");
    this._apiUrl = appConfig.baseUrl;
    this.maxvehage = appConfig.maxvehicleAge;
    this.maxYearsEligible = moment(
      new Date().setFullYear(new Date().getFullYear() - this.maxvehage)
    ).format("YYYY-MM-DD");
  }

  ngOnInit() {
    this.vehicleDetailFormBuild();
    this.getModels();
    this.getColors();
    this.getVehicleDetails();
    this.initializeNav(3);
    this.maxDate = moment();
  }

  initializeNav(compltedStep: number) {
    for (let i = 0; i <= compltedStep; i++) {
      this.step.stepNumber = i;
      this.step.completed = false;
      this.dataService.nextClick.next(this.step);
    }
  }

  vehicleDetailFormBuild() {
    this.vehicleDetailForm = new FormBuilder().group({
      vinChassisNo: [
        this.sellPolicyData.vinChassisNo,
        [Validators.required, Validators.pattern(MESSAGE_CONSTS.VIN_REGEX)],
      ],
      licensePlateNo: [
        this.sellPolicyData.licensePlateNo?.toUpperCase(),
        [Validators.pattern(MESSAGE_CONSTS.NUMBER_PLATE_REGEX)],
      ],
      model: [this.sellPolicyData.model, [Validators.required]],
      colorName: [this.sellPolicyData.colorName],
      vehicleSaleDate: [
        this.sellPolicyData.vehicleSaleDate,
        [Validators.required],
      ],
      variant: [this.sellPolicyData.variant,[Validators.pattern(MESSAGE_CONSTS.ALLOWED_SPECIALCHAR_REGEX)]],
      invoiceDate: [
        {
          value: new Date(),
          disabled: true,
        },
        Validators.required,
      ],
      otherDetails: this.sellPolicyData.otherDetails,
      workshopId: null,
      clientId: this.clientId,
      policyStatusId: 1,
      ageOfVehicle: this.sellPolicyData.ageOfVehicle,
      brand: [ {
        value: this.clientName,
        disabled: true,
      }, [Validators.required]],
      effectiveDate: this.sellPolicyData.effectiveDate,
      expiryDate: this.sellPolicyData.expiryDate,
    });
  }

  get purchaseDate() {
    return this.vehicleDetailForm.get("vehicleSaleDate");
  }
  get VehicleDetailFormControls() {
    return this.vehicleDetailForm.controls;
  }

  getColors(): void {
    this.authService
      .get(this._apiUrl + "/api/v1/Colors?pageNumber=-1")
      .subscribe(
        (response) => {
          if (response) {
            this.colorList = response;
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  getModels(): void {
    this.authService
      .get(this._apiUrl + "/api/v1/Models?pageNumber=-1")
      .subscribe(
        (response) => {
          if (response) {
            this.modelList = response;
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  //While coming back to page load data
  getVehicleDetails(): void {
    let resp = this.dataService.getData();
    if (resp) {
      this.sellPolicyData = resp;
      this.vehicleDetailFormBuild();
    }
  }

  //Based on Model Inclusive(default coverage will change)
  onModelSelected(value: string): void {
    this.selectedModel = this.modelList.filter((obj) => {
      if (
        obj.modelName.trim().toLowerCase() ==
        (value ?? " ").trim().toLowerCase()
      )
        return obj;
    });

    this.inclusiveCoverage =
      this.selectedModel.length == 0
        ? null
        : this.selectedModel[0].modelWarrenty;
    //console.info(this.inclusiveCoverage);
  }

  //On sale date change calculate vehicle age
  onVehicleSaleDateChange(): void {
    const saleDateValue = this.vehicleDetailForm.controls.vehicleSaleDate.value;
    if (!saleDateValue) {
      this.vehicleAge = 0;
      this.vehicleDetailForm.patchValue({ ageOfVehicle: 0 });
      return;
    }
    var saleDate = new Date(saleDateValue);
    var diffr = this.diffDate(saleDate, Date.now());

    if (diffr.years > 0) {
      this.vehicleAge = diffr.years; //diff in year > 0 then age is diff i years
      if (diffr.days > 0) this.vehicleAge = diffr.years + 1; //diff in year & days > 0 and then age is diff years +1
    } else {
      this.vehicleAge = 0; //0 years and 0 days diff then age = 1;
      if (diffr.days > 0) this.vehicleAge = 1; //0 years and more 1 daysdiff treated as 1 year
    }

    this.vehicleDetailForm.patchValue({
      ageOfVehicle: this.vehicleAge,
    });
  }

  Vinchanged(e): void {
    if (
      e.target.value != "" &&
      this.vehicleDetailForm.get("vinChassisNo").valid
    ) {
      this.resetForm();
      this.searchVinNumber(e.target.value);
    }
  }

  onSearchClick(): void {
    const vin = this.vehicleDetailForm.get("vinChassisNo").value;
    if (vin && this.vehicleDetailForm.get("vinChassisNo").valid) {
      this.resetForm();
      this.vehicleDetailForm.patchValue({ vinChassisNo: vin });
      this.searchVinNumber(vin);
    }
  }

  searchVinNumber(vin: any): void {
    this.sellPolicyData = new sellPolicyData();
    this.isExtend = false;
    this.isAged = false;
    this.isUnitySearch = false;
    this.expiryDateofExistingPolicy = undefined;
    this.vinNumber = vin;

    // Step 1: Always search Zoho first for latest vehicle & customer details
    this.authService
      .post(this._apiUrl + `/api/v1/Zoho/SearchVehicleByVin`, vin)
      .subscribe(
        (zohoResponse) => {
          if (zohoResponse.success) {
            // Zoho found the vehicle — prefill vehicle/customer fields
            this.prefillFromZoho(zohoResponse.data);

            // Step 2: Also check own DB to get real policy coverage dates & status flags
            this.authService
              .post(this._apiUrl + `/api/v1/PolicyDetails/SearchVin`, vin)
              .subscribe(
                (dbData) => {
                  if (dbData) {
                    // DB has a policy record — apply its coverage dates and flags
                    // This overrides Zoho's Mobilo_End_Date with our actual policy end date
                    this.applyPolicyCoverageFromDb(dbData);
                  }
                  // If DB has no record, flags already set in prefillFromZoho
                  // (using Zoho's expiryDate / undefined → treated as new policy)
                },
                (error) => { /* DB lookup failed — non-critical, continue with Zoho data */ }
              );
          } else {
            // Zoho has no record — fall back to DB then Unity
            this.authService
              .post(this._apiUrl + `/api/v1/PolicyDetails/SearchVin`, vin)
              .subscribe(
                (data) => {
                  if (data) {
                    this.prefillPolicy(data);
                  } else {
                    // Not in DB either — try Unity
                    this.authService
                      .post(this._apiUrl + `/api/v1/Unity/SearchVin`, vin)
                      .subscribe(
                        (unityResponse) => {
                          if (unityResponse.success) {
                            this.prefillPolicy(unityResponse.data);
                          } else {
                            this.resetFlags();
                            this.customErrorHandler.handleCustomInfo("No data found to Auto fill!");
                          }
                        },
                        (error) => {
                          this.resetFlags();
                          this.customErrorHandler.handleError("Sorry!!Failed to auto fill data");
                        }
                      );
                  }
                },
                (error) => {
                  this.resetFlags();
                  this.customErrorHandler.handleError(error);
                }
              );
          }
        },
        (error) => {
          this.resetFlags();
          this.customErrorHandler.handleError("Sorry!!Failed to auto fill data");
        }
      );
  }

  private resetFlags(): void {
    this.isExtend = false;
    this.isAged = false;
    this.maxInsured = false;
    this.isSellCancelledPolicyAgain = false;
    this.CancellationApprovalPending = false;
    this.templateDialogRef?.close();
  }

  // Applies policy coverage dates and status flags from DB record onto a Zoho-prefilled form.
  // Called after prefillFromZoho when the VIN also exists in our DB.
  applyPolicyCoverageFromDb(dbData: any): void {
    this.expiryDateofExistingPolicy = new Date(dbData.expiryDate);
    // Store DB expiry on sellPolicyData so plan page picks it up as originalExpiryDateForFiltering
    this.sellPolicyData.expiryDate = new Date(dbData.expiryDate);

    let insuredyeardiff = this.diffDate(
      new Date(this.sellPolicyData.vehicleSaleDate),
      new Date(dbData.expiryDate)
    );
    let maxinsuredage = insuredyeardiff.years;

    if (PolicyStatus.Cancel == dbData.policyStatusId) {
      this.isSellCancelledPolicyAgain = true;
      this.lastavailDate = new Date(dbData.updatedDate);
      this.expiryDateofExistingPolicy = this.lastavailDate;
      this.isExtend = false;
      this.isAged = false;
      this.maxInsured = false;
    } else if (PolicyStatus.CancelationApprovalPending == dbData.policyStatusId) {
      this.CancellationApprovalPending = true;
      this.isExtend = false;
      this.isAged = false;
      this.maxInsured = false;
    } else if (maxinsuredage >= this.maxvehage) {
      this.isAged = false;
      this.isExtend = false;
      this.maxInsured = true;
    } else if (this.expiryDateofExistingPolicy >= new Date()) {
      this.isAged = false;
      this.isExtend = true;
      this.maxInsured = false;
    } else if (this.vehicleAge > this.maxvehage) {
      this.isAged = true;
      this.isExtend = false;
      this.maxInsured = false;
    } else {
      this.templateDialogRef?.close();
    }
  }

  // Add this method to bind Zoho data to your form/model
  prefillFromZoho(zohoData: any): void {
     this.templateDialogRef = this.dialogService.open(this.templateRef, {
      ariaLabel: "Search dialoge",
    });
    // Vehicle details
    this.sellPolicyData.vinChassisNo = zohoData.vinChassisNo;
    this.sellPolicyData.licensePlateNo = zohoData.licensePlateNo;
    this.sellPolicyData.model = zohoData.model;
    this.sellPolicyData.colorName = zohoData.colorName;
    this.sellPolicyData.vehicleSaleDate = zohoData.vehicleSaleDate;
    this.sellPolicyData.variant = zohoData.variant;
    this.sellPolicyData.invoiceDate = zohoData.invoiceDate;
    this.sellPolicyData.otherDetails = zohoData.otherDetails;
    //this.sellPolicyData.brand = zohoData.brand;
    this.sellPolicyData.zohoVehicleId = zohoData.zohoVehicleId;
    this.sellPolicyData.zohoCustomerId = zohoData.zohoCustomerId;
    this.sellPolicyData.zohoBillToAccountId = zohoData.zohoBillToAccountId;

    // Customer details
    this.sellPolicyData.customerFirstName = zohoData.customerFirstName;
    this.sellPolicyData.customerLastName = zohoData.customerLastName;
    this.sellPolicyData.customerPhoneNo = zohoData.customerPhoneNo;
    this.sellPolicyData.customerMobileNo = zohoData.customerMobileNo;
    this.sellPolicyData.customerEmail = zohoData.customerEmail;
    this.sellPolicyData.customerCompany = zohoData.customerCompany;
    this.sellPolicyData.state = zohoData.state;
    this.sellPolicyData.city = zohoData.city;
    this.sellPolicyData.pincode = zohoData.pincode;
    this.sellPolicyData.customerAddress = zohoData.customerAddress;
    // Zoho's expiryDate is Mobilo_End_Date — may be null for vehicles with no Mobilo contract
    this.expiryDateofExistingPolicy = zohoData.expiryDate ? new Date(zohoData.expiryDate) : undefined;

    this.selectedModel = this.modelList.filter((obj) => {
      if (
        zohoData.model &&
        obj.modelName.toLowerCase() == (zohoData.model ?? " ").trim().toLowerCase()
      )
        return obj;
    });

    this.selectedColor = this.colorList.filter((obj) => {
      if (
        obj.colorName.toLowerCase() ==
        (zohoData.colorName ?? " ").trim().toLowerCase()
      )
        return obj;
    });

    this.sellPolicyData.model =
      this.selectedModel.length == 0 ? null : this.selectedModel[0].modelName;
    this.sellPolicyData.colorName =
      this.selectedColor.length == 0 ? null : this.selectedColor[0].colorName;

    this.vehicleDetailFormBuild();
    this.onVehicleSaleDateChange();
    if (zohoData.model) this.onModelSelected(zohoData.model);
    this.vehicleDetailForm.markAllAsTouched();

    // Set flags based on Zoho's Mobilo_End_Date.
    // If DB also has this VIN, applyPolicyCoverageFromDb() will run after this and override flags.
    if (zohoData.expiryDate && zohoData.vehicleSaleDate) {
      let insuredyeardiff = this.diffDate(
        new Date(zohoData.vehicleSaleDate),
        new Date(zohoData.expiryDate)
      );
      let maxinsuredage = insuredyeardiff.years;

      if (maxinsuredage >= this.maxvehage) {
        this.isAged = false;
        this.isExtend = false;
        this.maxInsured = true;
      } else if (this.expiryDateofExistingPolicy >= new Date()) {
        this.isAged = false;
        this.isExtend = true;
        this.maxInsured = false;
      } else if (this.vehicleAge > this.maxvehage) {
        this.isAged = true;
        this.isExtend = false;
        this.maxInsured = false;
      } else {
        this.templateDialogRef?.close();
      }
    } else if (this.vehicleAge > this.maxvehage) {
      // No Mobilo contract in Zoho and vehicle is too old
      this.isAged = true;
      this.isExtend = false;
      this.maxInsured = false;
    } else {
      // No Mobilo contract — treat as new policy, close loading modal
      this.templateDialogRef?.close();
    }
  }
  

  searchUnity(): void {
    this.authService
      .post(this._apiUrl + `/api/v1/Unity/SearchVin`, this.vinNumber)
      .subscribe(
        (response) => {
          if (response.success) {
            this.prefillPolicy(response.data);
          } else {
            this.templateDialogRef?.close();
            this.customErrorHandler.handleCustomInfo(response.responsemsg);
          }
        },
        (error) => {
          this.customErrorHandler.handleError(
            "Sorry!!Failed to auto fill data"
          );
          this.templateDialogRef?.close();
        }
      );
  }

  prefillPolicy(data): void {
    this.templateDialogRef = this.dialogService.open(this.templateRef, {
      ariaLabel: "Search dialoge",
    });

    this.expiryDateofExistingPolicy = new Date(data.expiryDate);

    this.sellPolicyData = data;

    //bind color and model
    this.selectedModel = this.modelList.filter((obj) => {
      if (
        data.model &&
        obj.modelName.toLowerCase() == (data.model ?? " ").trim().toLowerCase()
      )
        return obj;
    });

    this.selectedColor = this.colorList.filter((obj) => {
      if (
        obj.colorName.toLowerCase() ==
        (data.colorName ?? " ").trim().toLowerCase()
      )
        return obj;
    });

    this.sellPolicyData.model =
      this.selectedModel.length == 0 ? null : this.selectedModel[0].modelName;
    this.sellPolicyData.colorName =
      this.selectedColor.length == 0 ? null : this.selectedColor[0].colorName;

    this.vehicleDetailFormBuild();
    //For recalculating vehicle age based on sale date
    this.onVehicleSaleDateChange();
    if (data.model) this.onModelSelected(data.model);
    //to trigger validation
    this.vehicleDetailForm.markAllAsTouched();

    let insuredyeardiff = this.diffDate(
      new Date(data.vehicleSaleDate),
      new Date(data.expiryDate)
    );
    let maxinsuredage = insuredyeardiff.years;

    if (PolicyStatus.Cancel == data.policyStatusId) {
      this.isSellCancelledPolicyAgain = true;
      this.lastavailDate = new Date(data.updatedDate);
      // set expirydate into cancelled date inorderd to renew the policy
      this.expiryDateofExistingPolicy = this.lastavailDate;
    } else if (PolicyStatus.CancelationApprovalPending == data.policyStatusId) {
      this.CancellationApprovalPending = true;
    }  
   //Incase if a vehicle is exhausted with maximum policy renewal
   else if (maxinsuredage >= this.maxvehage) {
    this.isAged = false;
    this.isExtend = false;
    this.maxInsured = true;
  } else if (this.expiryDateofExistingPolicy >= new Date()) {
      //check vehicle policy is to Extend it or not
      this.isAged = false;
      this.isExtend = true;
      this.maxInsured = false;
    } else if (this.vehicleAge > this.maxvehage) {
      //incase of old vehicle which are not eligible for renewal
      this.isAged = true;
      this.isExtend = false;
      this.maxInsured = false;
    } else {
      this.templateDialogRef?.close();
    }
  }

  setEffectivePolicyStartDate(): void {
      //If inclusiveCoverage is undefinded find model and calculate
    if (this.inclusiveCoverage == undefined)
      this.onModelSelected(this.sellPolicyData.model);

    var vehiclesaleDate = new Date(
      this.vehicleDetailForm.controls.vehicleSaleDate.value
    );

    var companywarrantyendDate =  new Date(
      vehiclesaleDate.getFullYear() + this.inclusiveCoverage,
      vehiclesaleDate.getMonth(),
      vehiclesaleDate.getDate()
    );
    //re calculate expiry date when page comes backwards
    if (this.sellPolicyData.expiryDate != undefined && this.expiryDateofExistingPolicy == undefined) {
      // Use the preserved original expiry (stored before plan selection) for reliable reconstruction
      if (this.sellPolicyData.originalExpiryDateForFiltering) {
        this.expiryDateofExistingPolicy = new Date(this.sellPolicyData.originalExpiryDateForFiltering);
      } else {
        // Fallback arithmetic reconstruction for legacy data
        let diff = this.diffDate(this.sellPolicyData.effectiveDate, this.sellPolicyData.expiryDate);
        let d = new Date(this.sellPolicyData.expiryDate);
        this.expiryDateofExistingPolicy = new Date(d.getFullYear() - diff.years, d.getMonth(), d.getDate() - diff.days);
      }
    }
    //In case of New Policy
    if (this.expiryDateofExistingPolicy == undefined) {
      //Added Default cover to vehicle sale date
      this.policyStartDate = companywarrantyendDate;
      //Incaseof inclusive cover lapsed
      if (this.policyStartDate <= new Date()) {
        this.policyStartDate = new Date();
        //48 hours of activation period in case of expired policies
        this.policyStartDate.setDate(this.policyStartDate.getDate() + 2);
      }
    } else {
      //In case of policy extension
      //Policy is already expired
      if (this.expiryDateofExistingPolicy < new Date()) {
        this.policyStartDate = new Date();
        //48 hours of activation period in case of expired policies
        this.policyStartDate.setDate(this.policyStartDate.getDate() + 2);
        //incase expired/cancelled policy is covered in inclusive coverage 
        if(companywarrantyendDate > new Date())
        {
          this.policyStartDate = companywarrantyendDate;
        }
      } else {
        //set start date as expiry of previous policy
        this.policyStartDate = this.expiryDateofExistingPolicy;
      }
    }

    this.vehicleDetailForm.patchValue({
      effectiveDate: this.policyStartDate,
    });
  }

  setExpiryPolicyEndDate(): void {
      //If inclusiveCoverage is undefinded find model and calculate
    if (this.inclusiveCoverage == undefined)
      this.onModelSelected(this.sellPolicyData.model);

    var vehiclesaleDate = new Date(
      this.vehicleDetailForm.controls.vehicleSaleDate.value
    );

     //Setting vehicle expiry date as per inclusive year 3
    if (this.inclusiveCoverage == 0 && this.sellPolicyData.expiryDate == undefined){  

       var vehiclesaleDate = new Date(        
      this.vehicleDetailForm.controls.vehicleSaleDate.value
    );

     this.policyEndDate =  new Date(
      vehiclesaleDate.getFullYear() + 3,
      vehiclesaleDate.getMonth(),
      vehiclesaleDate.getDate()
    );

   this.vehicleDetailForm.patchValue({
      expiryDate: this.policyEndDate,
    });
    }
  }
  
  extendPolicy(): void {
    //this.vehicleDetailFormBuild();
    /*to trigger validation*/
    this.vehicleDetailForm.markAllAsTouched();

    this.isExtend = false;
    this.isAged = false;
    this.maxInsured = false;
    this.templateDialogRef?.close();
  }

  saveVehicleDetails(): void {
    this.setEffectivePolicyStartDate();
    this.setExpiryPolicyEndDate();
    this.sellPolicyData.vinChassisNo =
      this.vehicleDetailForm.get("vinChassisNo").value;
    this.sellPolicyData.licensePlateNo =
      this.vehicleDetailForm.get("licensePlateNo").value;
    this.sellPolicyData.model = this.vehicleDetailForm.get("model").value;
    this.sellPolicyData.colorName =
      this.vehicleDetailForm.get("colorName").value;
    this.sellPolicyData.vehicleSaleDate = new Date(
      moment(this.vehicleDetailForm.get("vehicleSaleDate").value).format(
        "YYYY-MM-DD HH:mm"
      )
    );
    this.sellPolicyData.variant = this.vehicleDetailForm.get("variant").value;
    this.sellPolicyData.invoiceDate = new Date(
      moment(this.vehicleDetailForm.get("invoiceDate").value).format(
        "YYYY-MM-DD HH:mm"
      )
    );
    this.sellPolicyData.otherDetails =
      this.vehicleDetailForm.get("otherDetails").value;
    this.sellPolicyData.clientId = this.clientId;
    this.sellPolicyData.workshopId = null;
    this.sellPolicyData.policyStatusId = 1;
    this.sellPolicyData.ageOfVehicle =
      this.vehicleDetailForm.get("ageOfVehicle").value;
    this.sellPolicyData.brand = this.vehicleDetailForm.get("brand").value;
    this.sellPolicyData.effectiveDate =
      this.vehicleDetailForm.get("effectiveDate").value;
    this.sellPolicyData.expiryDate =
      this.vehicleDetailForm.get("expiryDate").value;
    this.sellPolicyData.planId = null;
    this.sellPolicyData.price = null;
    this.sellPolicyData.gstPrice = null;
    this.dataService.setData(this.sellPolicyData);
    this.router.navigate(["/sellpolicy/customerdetails"]);

    this.step.stepNumber = 0;
    this.step.completed = true;
    this.dataService.nextClick.next(this.step);
  }

  resetForm(): void {
    this.isExtend = false;
    this.isAged = false;
    this.maxInsured = false;
    this.CancellationApprovalPending = false;
    this.isSellCancelledPolicyAgain = false;
    this.vehicleDetailForm.reset({
      vinChassisNo: this.vehicleDetailForm.get("vinChassisNo").value,
      brand: this.vehicleDetailForm.get("brand").value,
      invoiceDate: this.vehicleDetailForm.get("invoiceDate").value,
    });
  }

  clearForm(): void {
    this.sellPolicyData = new sellPolicyData();
    this.isExtend = false;
    this.isAged = false;
    this.maxInsured = false;
    this.CancellationApprovalPending = false;
    this.isSellCancelledPolicyAgain = false;
    this.isUnitySearch = false;
    this.vinNumber = null;
    this.expiryDateofExistingPolicy = undefined;
    this.vehicleAge = undefined;
    this.inclusiveCoverage = undefined;
    this.selectedModel = undefined;
    this.selectedColor = undefined;
    this.lastavailDate = undefined;
    this.templateDialogRef?.close();
    this.dataService.clearData(null);
    this.vehicleDetailForm.reset({
      brand: { value: this.clientName, disabled: true },
      invoiceDate: { value: new Date(), disabled: true },
    });
  }

  closeModal(): void {
    this.vehicleDetailForm.reset({
      brand: this.vehicleDetailForm.get("brand").value,
      invoiceDate: this.vehicleDetailForm.get("invoiceDate").value,
    });
    this.templateDialogRef?.close();
  }

  diffDate(startDate, endDate): any {
    var b = moment(startDate),
      a = moment(endDate),
      out: any = {};
    let intervals: moment.unitOfTime.DurationConstructor[] = ["years", "days"];

    for (var i = 0; i < intervals.length; i++) {
      var diff = a.diff(b, intervals[i]);
      b.add(diff, intervals[i]);
      out[intervals[i]] = diff;
    }
    return out;
  }
}
